import * as R from "ramda";
import * as Promise from "bluebird";
import { of, from, Observable, concat } from "rxjs";
import {
  mergeMap,
  map,
  catchError,
  withLatestFrom,
  switchMap,
} from "rxjs/operators";
import { combineEpics, ofType } from "redux-observable";
import {
  getDashboardDone,
  types,
  getJobBoardDashboardDone,
  getNewsDone,
  getVideosDone,
} from "./dashboard.redux";
import { datasources } from "../db/datasources";
import { act } from "react";

Promise.config({ warnings: false, longStackTraces: false, asyncHooks: false });

const getDashboard = ({
  proshopId,
  startingDate,
  endingDate,
  previousStartingDate,
  previousEndingDate,
}) =>
  new Promise((success, fail) => {
    const { dashboardDS } = datasources;
    dashboardDS
      .read({
        proshopId,
        startingDate,
        endingDate,
        previousStartingDate,
        previousEndingDate,
      })
      .then((dashboard) => success(dashboard))
      .catch((error) => fail(error));
  });

const getJobBoardDashboard = ({ proshopId, startingDate, endingDate, status, salesPerson, jobLocation, jobService }) =>
  new Promise((success, fail) => {
    const { jobBoardDashboardDS } = datasources;
    jobBoardDashboardDS
      .read({
        proshopId,
        startingDate,
        endingDate,
        status,
        salesPerson,
        jobLocation,
        jobService,
      })
      .then((dashboard) => success(dashboard))
      .catch((error) => fail(error));
  });

const getDashboardEpic = (action$, state$) =>
  action$.pipe(
    ofType(types.getDashboard),
    withLatestFrom(state$),
    mergeMap(([_, state]) => {
      const proshopId = state.userSession.proshopId;

      return from(
        getDashboard({
          proshopId: proshopId,
          startingDate: state.dashboard.startingDate,
          endingDate: state.dashboard.endingDate,
          previousStartingDate: state.dashboard.previousStartingDate,
          previousEndingDate: state.dashboard.previousEndingDate,
        })
      ).pipe(
        map((dashboard) => {
          return getDashboardDone({
            dashboard,
          });
        }),
        catchError(() => {
          return of(getDashboardDone({ dashboard: [] }));
        })
      );
    })
  );

const getJobBoardDashboardEpic = (action$, state$) =>
  action$.pipe(
    ofType(types.getJobBoardDashboard),
    withLatestFrom(state$),
    switchMap(([_, state]) => {
      const proshopId = state.userSession.proshopId;
      const filters = state.dashboard.jobBoardDashboardFilters;

      return from(
        getJobBoardDashboard({
          proshopId: proshopId,
          startingDate: filters.startingDate,
          endingDate: filters.endingDate,
          status: filters.status || "",
          salesPerson: filters.salesPerson || "",
          jobLocation: filters.jobLocation || "",
          jobService: filters.jobService || "",
        })
      ).pipe(
        map((job_board_dashboard) => {
          return getJobBoardDashboardDone({
            job_board_dashboard,
          });
        }),
        catchError(() => {
          return of(getJobBoardDashboardDone({ job_board_dashboard: [] }));
        })
      );
    })
  );

const getNewsEpic = (action$, state$) =>
  action$.pipe(
    ofType(types.getNews),
    withLatestFrom(state$),
    mergeMap(([_, state]) => {
      return from(
        fetch(
          "https://www.spectrebowling.com/wp-json/wp/v2/posts?categories=11&per_page=10&_embed=1"
        ).then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch news");
          }
          return response.json(); // Parse the JSON response
        })
      ).pipe(
        map((news) => {
          return getNewsDone({
            news,
          });
        }),
        catchError(() => {
          return of(getNewsDone({ news: [] }));
        })
      );
    })
  );

const getVideosEpic = (action$, state$) =>
  action$.pipe(
    ofType(types.getVideos),
    withLatestFrom(state$),
    mergeMap(([_, state]) => {
      const PLAYLIST_ID = "PLkwELarCtKPwO5uGtOITwTam88lGhviNb";
      const API_KEY = "AIzaSyC2_PXWNtXMBJgrRwQSoCUDyZS3IErX09k";
      //Find somewhere secure to store the apiKey
      return from(
        fetch(
          `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${PLAYLIST_ID}&maxResults=10&key=${API_KEY}`
        ).then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch videos");
          }
          return response.json(); // Parse the JSON response
        })
      ).pipe(
        map((videos) => {
          return getVideosDone({
            videos,
          });
        }),
        catchError(() => {
          return of(getVideosDone({ videos: [] }));
        })
      );
    })
  );

export default combineEpics(
  getDashboardEpic,
  getVideosEpic,
  getJobBoardDashboardEpic,
  getNewsEpic
);
